import { cognitoUserPoolsTokenProvider } from '@aws-amplify/auth/cognito';
import { GET_USERS } from '@watter/shared-components';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSession } from '../../store/reducers/appSlice';
import {
    setUserId,
    setUserName,
    setUserImageLink,
    updateLoginStatus,
    setUserPermissions,
} from '../../store/reducers/userSlice';
import { client } from '../../service/apolloClient';

import { INavigationConfig, NavigationConfig } from '../../utils/navigation-constants';
import { GET_USER_PERMISSIONS } from '../../graphql/queries';

const navConfig: INavigationConfig = NavigationConfig;

export const useHandleLoginOnSuccess = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleUserPermissions = async () => {
        const { data } = await client.query({
            query: GET_USER_PERMISSIONS,
            fetchPolicy: 'network-only',
        });
        const permissions: Record<string, any> = {};
        data?.getPermissions?.forEach((item: any) => {
            permissions[item.feature_slug] = {
                view: item.actions[0] === '1',
                create: item.actions[1] === '1',
                edit: item.actions[2] === '1',
                delete: item.actions[3] === '1',
            };
        });
        dispatch(setUserPermissions(permissions));
    };
    const handleLoginOnSuccess = async () => {
        const loginResponse = await cognitoUserPoolsTokenProvider.authTokenStore.loadTokens();

        if (loginResponse) {
            dispatch(
                setSession({
                    token: loginResponse?.idToken?.toString(),
                    payload: loginResponse?.idToken?.payload,
                }),
            );
            dispatch(updateLoginStatus(true));
            // get user permissions
            handleUserPermissions();
            navigate(navConfig.Home);

            try {
                const { data } = await client.query({ query: GET_USERS });
                const userId = data?.getUser?.id;
                const userName = `${data?.getUser?.first_name || ''} ${data?.getUser?.last_name || ''}`.trim();
                const userImageUrl = `${data?.getUser?.profile_image || ''}`;
                if (userName) {
                    dispatch(setUserName(userName));
                }
                if (userImageUrl) {
                    dispatch(setUserImageLink(userImageUrl));
                }

                if (userId) {
                    dispatch(setUserId(userId));
                } else {
                    console.warn('User ID not found in the response');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        }
    };

    return { handleLoginOnSuccess };
};
